import {
  Box,
  Checkbox,
  checkboxClasses,
  FormControlLabel,
} from "@mui/material";

type SeriesItem = {
  id: string;
  label: string;
  color: string;
  checked: boolean;
};

type SeriesToolbarProps = {
  items: SeriesItem[];
  onChange: (id: string, checked: boolean) => void;
};

export function SeriesToolbar({ items, onChange }: SeriesToolbarProps) {
  return (
    <Box
      width={"100%"}
      display={"flex"}
      flexWrap={"wrap"}
      justifyContent={"center"}
      sx={{ displayPrint: "none" }}
    >
      {items.map(({ id, label, color, checked }) => (
        <FormControlLabel
          key={id}
          control={
            <Checkbox
              sx={{
                color,
                [`&.${checkboxClasses.checked}`]: { color },
              }}
            />
          }
          label={label}
          checked={checked}
          onChange={(_, value) => onChange(id, value)}
        />
      ))}
    </Box>
  );
}
